var today: Date = new Date();
var currentHour: number = today.getHours();
var greeting: string = "";
const link: string = "https//dinapama.unicomms.app";
const username: string = "Project Management System";

if (currentHour < 12) {
  greeting = "Good Morning";
} else if (currentHour < 18) {
  greeting = "Good Afternoon";
} else {
  greeting = "Good Evening";
}
// SCORECARD DRAFT MAIL NOTIFICATIONS
export const MAIL_SCORECARD_DRAFT_SUBMITTED_MANAGER = (
  name: string | null = ""
) => {
  const SUBJECT = `${name} - Scorecard Submission`;
  const BODY = [
    `${greeting},`,
    "",
    `${name} has submitted a draft scorecard for review.`,
    "",
    "Visit Project Management System: https:/dinapama.unicomms.app for more.",
    "",
    "Sincerely,",
    // name,
    "Project Management System",
  ];

  return {
    SUBJECT: SUBJECT,
    BODY: BODY.join("<br/>"),
  };
};

export const MAIL_SCORECARD_DRAFT_SUBMITTED_ME = (name: string | null = "") => {
  const MY_SUBJECT = `${name} - Scorecard Submission`;
  const MY_BODY = [
    `${greeting},`,
    "",
    `Your draft scorecard has been successfully submitted to your manager for approval.`,
    "",
    "Project Management System",
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

// SCORECARD Q2 MAIL NOTIFICATIONS
export const MAIL_SCORECARD_Q2_SUBMITTED_MANAGER = (
  name: string | null = ""
) => {
  const SUBJECT = `Mid-Term Submission`;
  const BODY = [
    `${greeting},`,
    "",
    `${name} has submitted a draft mid-term progress update for review.`,
    "",
    "Visit Project Management System: https:/dinapama.unicomms.app for more.",
    "",
    "Sincerely,",
    // name,
    "Project Management System",
  ];

  return {
    SUBJECT: SUBJECT,
    BODY: BODY.join("<br/>"),
  };
};

export const MAIL_SCORECARD_Q2_SUBMITTED_ME = (name: string | null = "") => {
  const MY_SUBJECT = `${name} - Mid-Term Submission`;
  const MY_BODY = [
    `${greeting},`,
    "",
    "Your mid-term progress update has been successfully submitted to your manager for approval.",
    "",
    "Visit Project Management System: https:/dinapama.unicomms.app for more.",
    "",
    "Project Management System",
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

// SCORECARD Q4 MAIL NOTIFICATIONS
export const MAIL_SCORECARD_Q4_SUBMITTED_MANAGER = (
  name: string | null = ""
) => {
  const SUBJECT = `Assessment Submission`;
  const BODY = [
    `${greeting},`,
    "",
    `${name}  has submitted their self assessment for your review.`,
    "",
    "Visit Project Management System: https:/dinapama.unicomms.app for more.",
    "",
    "Sincerely,",
    // name,
    "Project Management System",
  ];

  return {
    SUBJECT: SUBJECT,
    BODY: BODY.join("<br/>"),
  };
};
export const MAIL_SCORECARD_Q4_SUBMITTED_ME = (name: string | null = "") => {
  const MY_SUBJECT = `${name} - Appraisal Submission`;
  const MY_BODY = [
    `${greeting},`,
    "",
    "Your self assesment has been successfully submitted to your line manager for approval.",
    "",
    "Visit Project Management System: https:/dinapama.unicomms.app for more.",
    "",
    "Project Management System",
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

export const MAIL_WELCOME_ME = () => {
  const MY_SUBJECT = `Welcome to the E-Performance Management System`;
  const MY_BODY = [
    `Congrats, your e-performance management system account is now ready. 
    You see your objectives, give/get feedback, record your development plans 
    and see your alignment with company goals and vision.`,
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join(""),
  };
};

export const WELCOME_BODY = [
  `Congrats, your project management system account is now ready.`,
  "",
  "Best Regards,",
  "HR Team",
];
export const WELCOME_SUBJECT = `Welcome to the E-Performance Management System`;
export const WELCOME_MESSAGE = WELCOME_BODY.join("<br/>");
export const MAIL_EMAIL = "no-reply@unicomms.app";


export const MAIL_MIDTERM_RATINGS_ME = (
  employeeName: string | null | undefined,
  supervisorName: string | null | undefined
) => {
  const MY_SUBJECT = `${employeeName}, Midterm Contract ratings`;
  const MY_BODY = [
    `${greeting},`,
    "",
    `Your midterm contract has been rated by ${supervisorName}.`,
    "",
    "Regards,",
    "Project Management System",
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

export const MAIL_ASSESSMENT_RATINGS_ME = (
  employeeName: string | null | undefined,
  supervisorName: string | null | undefined
) => {
  const MY_SUBJECT = `${employeeName}, Assessment Contract Ratings`;
  const MY_BODY = [
    `${greeting},`,
    "",
    `Your Assessment contract has been rated by ${supervisorName}.`,
    "",
    "Regards,",
    "Project Management System",
  ];
  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

export const MAIL_SCORECARD_APPROVED_ME = (
  employeeName: string | null | undefined,
  supervisorName: string | null | undefined
) => {
  const MY_SUBJECT = `${employeeName}, Peformance Contract Approval`;
  const MY_BODY = [
    `${greeting},`,
    "",
    `Your peformance contract has been approved by ${supervisorName}.`,
    "",
    "Regards,",
    "Project Management System",
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};
export const MAIL_SCORECARD_REJECTED_ME = (
  employeeName: string | null | undefined,
  supervisorName: string | null | undefined
) => {
  const MY_SUBJECT = `${employeeName}, Peformance Contract Rejection`;
  const MY_BODY = [
    `${greeting},`,
    "",
    `Your peformance contract has been rejected by ${supervisorName}.`,
    "",
    "Regards,",
    "Project Management System",
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

export const MAIL_MIDTERM_APPROVED_ME = (
  employeeName: string | null | undefined,
  supervisorName: string | null | undefined
) => {
  const MY_SUBJECT = `${employeeName}, Mid-Term Approval`;
  const MY_BODY = [
    `${greeting},`,
    "",
    `Your midterm scorecard has been successfully approved by ${supervisorName}.`,
    "",
    "Regards,",
    "Project Management System",
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};
export const MAIL_MIDTERM_REJECTED_ME = (
  employeeName: string | null | undefined,
  supervisorName: string | null | undefined
) => {
  const MY_SUBJECT = `${employeeName}, Mid-Term Rejection`;
  const MY_BODY = [
    `${greeting},`,
    "",
    `Your midterm scorecard has been rejected by ${supervisorName}.`,
    "",
    "Regards,",
    "Project Management System",
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

export const MAIL_ASSESSMENT_APPROVED_ME = (
  employeeName: string | null | undefined,
  supervisorName: string | null | undefined
) => {
  const MY_SUBJECT = `${employeeName}, Assessment Approval`;
  const MY_BODY = [
    `${greeting},`,
    "",
    `Your assessment scorecard has been successfully approved by ${supervisorName}.`,
    "",
    "Regards,",
    "Project Management System",
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

export const MAIL_ASSESSMENT_REJECTED_ME = (
  employeeName: string | null | undefined,
  supervisorName: string | null | undefined
) => {
  const MY_SUBJECT = `${employeeName}, Assessment Rejection`;
  const MY_BODY = [
    `${greeting},`,
    "",
    `Your assessment scorecard has been rejected by ${supervisorName}.`,
    "",
    "Regards,",
    "Project Management System",
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

export const MAIL_FEEDBACK = (sender: string | unknown, message: string) => {
  const SUBJECT = `Feedback`;
  const BODY = [
    `${greeting}`,
    "",
    `${message} ${sender}`,
    "",
    "Regards,",
    `${username}`,
  ];

  return {
    MY_SUBJECT: SUBJECT,
    MY_BODY: BODY.join("<br/>"),
  };
};

export const MAIL_PROJECT_ADDED = (employeeName: string, project: string) => {
  const MY_SUBJECT = `${project}`;
  const MY_BODY = [
    `${greeting}`,
    "",
    `You were added to a project (${project}) by ${employeeName}`,

    `Visit ${link} for more details`,
    "",
    "Regards,",
    `${username}`,
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

export const MAIL_TASK_ADDED = (
  userName: string | null,//adder
  projectName: string,
  taskName: string,
) => {
  const MY_SUBJECT = `${taskName}`;
  const MY_BODY = [
    `${greeting}`,

    `You were added to a task ${taskName} in project ${projectName}`,
    `Visit ${link} for more details`,
    "",
    "Regards,",
    `${userName}`,
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

export const MAIL_PROJECT_TASK_ADDED = (
  employeeName: string | null | undefined, //adder
  name: string | null | undefined, //project name or task
  type: "project" | "task",
  project?: string | null | undefined,
) => {
  const MY_SUBJECT = `${project}`;
  const MY_BODY = [
    `${greeting}`,
    "",
    (type === "project") ? `You were added to a project (${name}) by ${employeeName}` : "",
    (type === "task") ? `You were added to a task ${name} in project ${project}` : "",
    `Visit ${link} for more details`,
    "",
    "Regards,",
    `${username}`,
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};

export const MAIL_MILESTONE_BILL = (
  message: string | null | undefined, //message
  name: string | null | undefined,
) => {  //message
  const MY_SUBJECT = `Mistone Billing`;
  const MY_BODY = [
    `${greeting}`,
    "",
    `${message}`,
    "",
    `Visit ${link} for more details`,
    "",
    "Regards,",
    `${username}`,
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};
export const MAIL_PROJECT_TASK_REMOVED = (
  employeeName: string | null | undefined, //adder
  name: string | null | undefined, //project name or task
  type: "project" | "task",
  project?: string | null | undefined,
) => {
  const MY_SUBJECT = `${project}`;
  const MY_BODY = [
    `${greeting}`,
    "",
    (type === "project") ? `You were removed to a project (${name}) by ${employeeName}` : "",
    (type === "task") ? `You were removed to a task ${name} in project ${project}` : "",
    `Visit ${link} for more details`,
    "",
    "Regards,",
    `${username}`,
  ];

  return {
    MY_SUBJECT: MY_SUBJECT,
    MY_BODY: MY_BODY.join("<br/>"),
  };
};